// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pw_a bia_ea bia_ke bia_ju bia_a bia_j bia_so bia_sp","SearchPanel__icon":"pw_b bia_vo bia_hi bia_su bia_va","SearchPanel__input":"pw_c bia_jb bia_eg bia_z"};